<template>
  <AdminCrudPage
    collection-name="packages"
    title="Umrah Packages"
    singular-title="Package"
    :fields="fields"
    :columns="columns"
    :seed-data="seedData"
  />
</template>

<script>
import AdminCrudPage from './AdminCrudPage.vue'
import economyImage from '../../assets/images/madina/madina-daytime-wide.jpg'
import executiveImage from '../../assets/images/madina/madina-rooftop-sunset.webp'
import familyImage from '../../assets/images/madina/madina-aerial-blue-night.jpg'
import luxuryImage from '../../assets/images/madina/madina-sunset-panorama.jpg'
import ramadanImage from '../../assets/images/madina/madina-dome-night-closeup.jpg'

const coupleImage = 'https://images.unsplash.com/photo-1590490360182-c33d57733427?w=800&q=80'
const extendedFamilyImage = 'https://images.unsplash.com/photo-1611048267451-e6ed903d4a38?w=800&q=80'
const friendsImage = 'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=800&q=80'
const ladiesGroupImage = 'https://images.unsplash.com/photo-1542816417-0983c9c9ad53?w=800&q=80'
const vipImage = 'https://images.unsplash.com/photo-1580418827493-f2b22c0a76cb?w=800&q=80'

export default {
  name: 'AdminPackages',
  components: { AdminCrudPage },
  data() {
    return {
      columns: [
        { key: 'title', label: 'Title' },
        { key: 'category', label: 'Category' },
        { key: 'nights', label: 'Nights' },
        { key: 'months', label: 'Months' }
      ],
      fields: [
        { key: 'title', label: 'Title', type: 'text', required: true },
        { key: 'category', label: 'Category (e.g. Signature, Premium, Economy)', type: 'text' },
        { key: 'image', label: 'Image', type: 'image' },
        { key: 'nights', label: 'Nights / Days (e.g. "10 Nights / 11 Days")', type: 'text' },
        { key: 'cities', label: 'City Breakdown (e.g. "6 nights Makkah • 4 nights Madina")', type: 'text' },
        { key: 'hotels', label: 'Hotels', type: 'stringList', example: 'Makkah: Swissôtel Al Maqam, Madina: The Oberoi' },
        { key: 'months', label: 'Available Months', type: 'stringList', example: 'August 2026, September 2026' },
        { key: 'flightIncluded', label: 'Flights Included', type: 'boolean', checkboxLabel: 'Return flights included' },
        { key: 'pricing', label: 'Pricing by Room Type', type: 'pricingRows' }
      ],
      seedData: [
        {
          title: 'Economy Umrah Package',
          category: 'Economy',
          image: economyImage,
          nights: '7 Nights / 8 Days',
          cities: '4 nights Makkah • 3 nights Madina',
          hotels: ['Makkah: Al Kiswah Towers', 'Madina: Dar Al Eiman Royal'],
          months: ['August 2026', 'September 2026', 'October 2026'],
          flightIncluded: true,
          pricing: [
            { type: 'Sharing (6-8 pax)', price: 125000 },
            { type: 'Quad', price: 145000 },
            { type: 'Triple', price: 165000 },
            { type: 'Double', price: 195000 },
            { type: 'Couple', price: 210000 }
          ]
        },
        {
          title: 'Executive Umrah Retreat',
          category: 'Premium',
          image: executiveImage,
          nights: '10 Nights / 11 Days',
          cities: '6 nights Makkah • 4 nights Madina',
          hotels: ['Makkah: Jabal Omar Hyatt Regency', 'Madina: The Oberoi'],
          months: ['September 2026', 'October 2026', 'November 2026'],
          flightIncluded: true,
          pricing: [
            { type: 'Sharing (6-8 pax)', price: 165000 },
            { type: 'Quad', price: 195000 },
            { type: 'Triple', price: 225000 },
            { type: 'Double', price: 265000 },
            { type: 'Couple', price: 295000 }
          ]
        },
        {
          title: 'Family Comfort Package',
          category: 'Value Plus',
          image: familyImage,
          nights: '12 Nights / 13 Days',
          cities: '7 nights Makkah • 5 nights Madina',
          hotels: ['Makkah: Hilton Convention', 'Madina: Pullman Zamzam'],
          months: ['October 2026', 'November 2026', 'December 2026'],
          flightIncluded: true,
          pricing: [
            { type: 'Sharing (6-8 pax)', price: 145000 },
            { type: 'Quad', price: 175000 },
            { type: 'Triple', price: 205000 },
            { type: 'Double', price: 245000 },
            { type: 'Couple', price: 265000 }
          ]
        },
        {
          title: 'Luxury Quad Stay',
          category: 'Signature',
          image: luxuryImage,
          nights: '7 Nights / 8 Days',
          cities: '5 nights Makkah • 2 nights Madina',
          hotels: ['Makkah: Swissôtel Al Maqam (Kaaba view)', 'Madina: Anwar Al Madinah Mövenpick'],
          months: ['November 2026', 'December 2026', 'January 2027'],
          flightIncluded: true,
          pricing: [
            { type: 'Sharing (6-8 pax)', price: 155000 },
            { type: 'Quad', price: 185000 },
            { type: 'Triple', price: 210000 },
            { type: 'Double', price: 245000 },
            { type: 'Couple', price: 270000 }
          ]
        },
        {
          title: 'Ramadan Special Umrah Package',
          category: 'Ramadan Special',
          image: ramadanImage,
          nights: '15 Nights / 16 Days',
          cities: '8 nights Makkah • 7 nights Madina',
          hotels: ['Makkah: Swissôtel Al Maqam (Kaaba view)', 'Madina: Anwar Al Madinah Mövenpick'],
          months: ['March 2027', 'April 2027'],
          flightIncluded: true,
          pricing: [
            { type: 'Sharing (6-8 pax)', price: 285000 },
            { type: 'Quad', price: 325000 },
            { type: 'Triple', price: 365000 },
            { type: 'Double', price: 425000 },
            { type: 'Couple', price: 465000 }
          ]
        },
        {
          title: "Couple's Private Umrah Package",
          category: 'Couples',
          image: coupleImage,
          nights: '7 Nights / 8 Days',
          cities: '4 nights Makkah • 3 nights Madina',
          hotels: ['Makkah: Swissôtel Al Maqam (Kaaba view)', 'Madina: The Oberoi', 'Private double room throughout, no sharing'],
          months: ['September 2026', 'October 2026', 'November 2026'],
          flightIncluded: true,
          pricing: [
            { type: 'Double (Private Room)', price: 220000 },
            { type: 'Couple (Kaaba View Upgrade)', price: 260000 }
          ]
        },
        {
          title: 'Extended Family Umrah Package',
          category: 'Families',
          image: extendedFamilyImage,
          nights: '14 Nights / 15 Days',
          cities: '8 nights Makkah • 6 nights Madina',
          hotels: ['Makkah: Jabal Omar Hyatt Regency (connecting rooms)', 'Madina: Pullman Zamzam Madina', 'Kids stay & eat free (under 6)'],
          months: ['November 2026', 'December 2026', 'January 2027'],
          flightIncluded: true,
          pricing: [
            { type: 'Sharing (6-8 pax)', price: 155000 },
            { type: 'Quad', price: 185000 },
            { type: 'Triple', price: 215000 },
            { type: 'Double', price: 255000 },
            { type: 'Family Suite (5-6 pax)', price: 235000 }
          ]
        },
        {
          title: 'Friends Group Umrah Package',
          category: 'Friends',
          image: friendsImage,
          nights: '9 Nights / 10 Days',
          cities: '5 nights Makkah • 4 nights Madina',
          hotels: ['Makkah: Hilton Convention Makkah', 'Madina: Elaf Taiba Hotel', 'Free group WhatsApp coordinator'],
          months: ['August 2026', 'September 2026', 'December 2026'],
          flightIncluded: true,
          pricing: [
            { type: 'Sharing (6-8 pax)', price: 135000 },
            { type: 'Quad', price: 160000 },
            { type: 'Triple', price: 180000 }
          ]
        },
        {
          title: 'Ladies Group Umrah Package',
          category: 'Ladies Group',
          image: ladiesGroupImage,
          nights: '10 Nights / 11 Days',
          cities: '6 nights Makkah • 4 nights Madina',
          hotels: ['Makkah: Swissôtel Al Maqam (Kaaba view)', 'Madina: Anwar Al Madinah Mövenpick', 'Dedicated female group coordinator & mahram-compliant arrangements'],
          months: ['October 2026', 'November 2026', 'March 2027'],
          flightIncluded: true,
          pricing: [
            { type: 'Sharing (6-8 pax)', price: 150000 },
            { type: 'Quad', price: 175000 },
            { type: 'Triple', price: 200000 },
            { type: 'Double', price: 235000 }
          ]
        },
        {
          title: 'Royal VIP Luxury Umrah Package',
          category: 'Ultra Luxury',
          image: vipImage,
          nights: '10 Nights / 11 Days',
          cities: '6 nights Makkah • 4 nights Madina',
          hotels: ['Makkah: Raffles Makkah Palace (Kaaba view suite)', 'Madina: The Oberoi', 'Private chauffeur & VIP fast-track Haram access'],
          months: ['December 2026', 'January 2027', 'February 2027'],
          flightIncluded: true,
          pricing: [
            { type: 'Double Suite', price: 450000 },
            { type: 'Couple (Royal Suite)', price: 520000 }
          ]
        }
      ]
    }
  }
}
</script>
